import React from 'react';
import { Box, Flex, Heading, HStack, Text } from '@chakra-ui/react';
import { Users } from 'lucide-react';
import { useAppSelector } from '@/stores';
import { selectCurrentTeam } from '@/stores/selectors/chat-selectors';

export const TeamSection: React.FC = () => {
  const currentTeam = useAppSelector(selectCurrentTeam);

  // Don't show if no team or if the name looks like a PD subdomain slug
  // (e.g. "pdt-acmehotel-1") — real team names always contain spaces or mixed case
  if (!currentTeam) return null;
  if (/^[a-z0-9][a-z0-9-]*[a-z0-9]$/.test(currentTeam.name)) return null;

  return (
    <Box>
      <Flex justify="space-between" align="center" mb={2}>
        <Heading size="sm" color="gray.700">
          Team
        </Heading>
      </Flex>
      <HStack
        spacing={2}
        px={3}
        py={2}
        bg="green.50"
        border="1px solid"
        borderColor="green.200"
        borderRadius="md"
        align="center"
      >
        <Box color="green.500" flexShrink={0}>
          <Users size={14} />
        </Box>
        <Text fontSize="sm" fontWeight="semibold" color="green.800" noOfLines={1}>
          {currentTeam.name}
        </Text>
      </HStack>
    </Box>
  );
};
